export default {"src":"/_next/static/media/profile-pro.3668a05d.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};